<template>
<div id="marketing-modal">
  <el-dialog
    v-model="value"
    top="50%"
    custom-class="marketing-modal-modal"
    :close-on-click-modal="false">

    <div class="marketing-modal-box">
      <div class="marketing-modal-content" @click="gotoActivityUrl()">
        <img class="img" :src="marketingModalInfo.pc_pop_image" alt="">
      </div>
      <div class="close-btn" @click="closechargeCoupon()"><img src="../../../assets/imgs/coupon/modal-close.png"></div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';

export default {
  name: 'marketing-modal',
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },

    // 充值赠送优惠券数据
    marketingModalInfo: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },

  methods: {
    // 关闭
    closechargeCoupon() {
      this.$emit('input', false);

      const marketingActivity = localStorage.getItem('marketingActivity') ? JSON.parse(localStorage.getItem('marketingActivity')) : {};
      marketingActivity[this.marketingModalInfo.id] = true;
      localStorage.setItem('marketingActivity', JSON.stringify(marketingActivity));
    },
    gotoActivityUrl() {
      if (this.marketingModalInfo.pc_jump_link) {
        sensorsdata.track('PopWindowClick', {
          page_from: '首页',
          activity_name: this.marketingModalInfo.title,
          activity_id: this.marketingModalInfo.id,
        });
        window.open(this.marketingModalInfo.pc_jump_link);
      }
    },
  },

};
</script>

<style lang="less">
#marketing-modal {
  .marketing-modal-modal {
    transform: translate(-50%,-50%);
    width: 440px;
    // box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.2);
    box-shadow: none;
	  background: transparent;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      .marketing-modal-box {
        position: relative;
        display: flex;
        justify-content: center;
        .marketing-modal-content {
          position: relative;
          cursor: pointer;
          border-radius: 12px;
          overflow: hidden;
          .img {
            width: 100%;
          }
        }
        .close-btn {
          position: absolute;
          bottom: -81px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          font-size: 0;
          cursor: pointer;
          img {
            width: 36px;
            height: 36px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/marketing-modal.vue